module.exports = __WEBPACK_EXTERNAL_MODULE_36__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"text-encoding","commonjs2":"text-encoding","amd":"text-encoding","root":"text-encoding"}
// module id = 36
// module chunks = 0